/**
 * WordPress dependencies
 */
const { Component, Fragment } = wp.element;
const { __ } = wp.i18n;

export default class MappingValueField extends Component {

	/**
	 * Initialize Gravity Forms Merge Tag UI on mount.
	 *
	 * @since 2.5
	 */
	componentDidMount() {

		this.$input       = jQuery( this.input );
		this.mergeTagsObj = new gfMergeTagsObj( form, this.$input );

		this.$input.on( 'propertychange', ( e ) => { this.props.updateMapping( { ...this.props.mapping, custom_value: e.target.value }, this.props.index ) } );

	}

	/**
	 * Destroy merge tag object and remove event listeners.
	 *
	 * @since 2.5
	 */
	componentWillUnmount() {

		this.$input.off( 'propertychange' );
		this.mergeTagsObj.destroy();

	}

	render() {
			const containerClass = this.props.mergeTagSupport ? 'gform-settings-generic-map__custom gform-settings-input__container--with-merge-tag' : 'gform-settings-generic-map__custom';
			const inputClass = this.props.mergeTagSupport ? 'merge-tag-support mt-position-right' : '';
			return (
				<span className={ containerClass }>
					<input ref={ input => this.input = input } id={ this.props.fieldId } type="text" className={ inputClass } value={ this.props.mapping.custom_value } placeholder={ this.props.valueField.placeholder } onChange={ ( e ) => this.props.updateMapping( { ...this.props.mapping, custom_value: e.target.value }, this.props.index ) } />
					<button className="gform-settings-generic-map__reset" onClick={ ( e ) => { e.preventDefault(); this.props.updateMapping( { ...this.props.mapping, value: '', custom_value: '' }, this.props.index ); } }>
						<span className="screen-reader-text">{ __( 'Remove Custom Value', 'gravityforms' ) }</span>
					</button>
				</span>
			);
	}

}
